export default "__VITE_ASSET__Bgw8AwXK__"